import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

const options = {
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json",
  },
};

/**
 * Fichiers d'aide d'un sujet (context) ou de tous les sujets.
 * Réponse : [{ context, files: [{ id, name, url, file_extension, completed_at, ... }] }]
 */
function help(context = null) {
  return axios
    .get(`${url}/trainings/help`, {
      ...options,
      params: context ? { context } : {},
    })
    .then((response) => response.data.data);
}

function updateHelp(context, fileIds) {
  return axios
    .patch(`${url}/trainings/help/${context}`, { files: fileIds }, options)
    .then((response) => response.data.data);
}

/** Réponse : { files, total, completed } */
function myPath() {
  return axios
    .get(`${url}/trainings/my-path`, options)
    .then((response) => response.data.data);
}

/** Réponse : { file_id, completed_at } (completed_at null si décoché) */
function setCompleted(fileId, completed) {
  return axios
    .post(`${url}/trainings/files/${fileId}/completion`, { completed }, options)
    .then((response) => response.data.data);
}

/**
 * Point atteint dans une vidéo, en secondes.
 * Réponse : { file_id, watched_seconds, duration_seconds }
 */
function saveProgress(fileId, position, duration) {
  return axios
    .post(
      `${url}/trainings/files/${fileId}/progress`,
      { position, duration },
      options
    )
    .then((response) => response.data.data);
}

/** Réponse : [{ id, name, users_count, files }] */
function paths() {
  return axios
    .get(`${url}/trainings/paths`, options)
    .then((response) => response.data.data);
}

function updatePath(roleId, fileIds) {
  return axios
    .patch(`${url}/trainings/paths/${roleId}`, { files: fileIds }, options)
    .then((response) => response.data.data);
}

/** Réponse : [{ id, firstname, lastname, email, roles, total, completed, finished_at, reminded_at, video_exempt }] */
function followUp() {
  return axios
    .get(`${url}/trainings/follow-up`, options)
    .then((response) => response.data.data);
}

function remind(userId) {
  return axios
    .post(`${url}/trainings/follow-up/${userId}/remind`, {}, options)
    .then((response) => response.data.data);
}

/** Réponse : { force_video_completion, exempt_users, users: [{ id, firstname, lastname, email, roles }] } */
function settings() {
  return axios
    .get(`${url}/trainings/settings`, options)
    .then((response) => response.data.data);
}

function updateSettings(forceVideoCompletion, exemptUserIds) {
  return axios
    .patch(
      `${url}/trainings/settings`,
      {
        force_video_completion: forceVideoCompletion,
        exempt_users: exemptUserIds,
      },
      options
    )
    .then((response) => response.data.data);
}

export default {
  help,
  updateHelp,
  myPath,
  setCompleted,
  saveProgress,
  paths,
  updatePath,
  followUp,
  remind,
  settings,
  updateSettings,
};
